function configure(Highcharts) {
    // Override numberFormat to use the unicode minus sign instead of the standard dash.
    var numberFormat = Highcharts.numberFormat;
    Highcharts.numberFormat = function (number, decimals, decimalPoint, thousandsSep) {
        return numberFormat(number, decimals, decimalPoint, thousandsSep).replace("-", "\u2212");
    };
    Highcharts.setOptions({
        chart: {
            spacing: [7, 1, 3, 0],
            plotBorderWidth: 0,
            plotBorderColor: "#000",
            backgroundColor: "rgba(255,255,255,0)",
            numberFormatter: Highcharts.numberFormat,
            style: {
                color: "#333",
                fontFamily: "Arial, Helvetica, sans-serif",
                fontSize: "12px"
            },
            events: {
                click: function () {
                    //@ts-ignore
                    this.tooltip.hide(0);
                }
            }
        },
        colors: [
            "#2C548A",
            "#DF8108",
            "#666666",
            "#6C88AD",
            "#E9A753",
            "#949494",
            "#B6C4D6",
            "#F4D3A9",
            "#CACACA"
        ],
        title: {
            style: {
                color: "inherit",
                fontSize: "115%",
                fontWeight: "bold"
            }
        },
        subtitle: {
            style: {
                color: "inherit",
                fontSize: "100%",
                fontWeight: "normal"
            }
        },
        caption: {
            style: {
                fontSize: "80%",
                color: "#666"
            }
        },
        credits: {
            enabled: true,
            text: "",
            href: null,
            position: {
                align: "left",
                verticalAlign: "bottom",
                x: 10,
                y: -10
            },
            style: {
                cursor: "default",
                color: "#666",
                fontSize: "80%",
                fontWeight: "normal"
            }
        },
        labels: {
            style: {
                color: "inherit",
                fontSize: "100%",
                fontWeight: "normal"
            }
        },
        legend: {
            margin: 10,
            title: {
                style: {
                    color: "inherit",
                    fontSize: "100%",
                    fontWeight: "normal"
                }
            },
            itemStyle: {
                color: "inherit",
                fontSize: "100%",
                fontWeight: "normal"
            }
        },
        tooltip: {
            shared: true,
            followPointer: true,
            useHTML: true,
            shadow: false,
            borderRadius: 0,
            borderWidth: 1,
            borderColor: "#aaa",
            backgroundColor: "rgba(245,245,245,.9)",
            headerFormat: '<span>{point.key}</span><br><table style="font: inherit; white-space: nowrap; color: inherit;">',
            pointFormat: '<tr><td><span style="color:{series.color}">\u25CF</span>&nbsp;{series.name}:&nbsp;</td><td style="text-align: right; font-weight:bold">{point.y}</td></tr>',
            footerFormat: '</table>',
            style: {
                color: "inherit",
                fontSize: "100%",
                fontWeight: "normal"
            }
        },
        xAxis: {
            lineWidth: 1,
            lineColor: "#aaa",
            tickWidth: 1,
            tickColor: "#aaa",
            tickLength: 8,
            gridLineWidth: 0,
            gridLineColor: "#ddd",
            minPadding: 0,
            maxPadding: 0,
            crosshair: {
                color: "rgba(0,0,0,0.1)"
            },
            title: {
                style: {
                    color: "inherit",
                    fontSize: "95%",
                    fontWeight: "normal"
                }
            },
            showLastLabel: true,
            labels: {
                //step: 1, // does not work in version 4.1.x - 6.0 (6.0 disables autoRotation)
                staggerLines: 1,
                style: {
                    color: "inherit",
                    fontSize: "95%",
                    fontWeight: "normal",
                    //whiteSpace: "nowrap"
                }
            },
            // Highcharts 4.1.x fix: xAxis.labels.step = 1 is only working this way.
            tickPositioner: function () {
                if (this.categories) {
                    var positions = [];
                    //@ts-ignore
                    for (var i = this.dataMin; i <= this.dataMax; ++i) {
                        positions.push(i);
                    }
                    return positions;
                }
                return null; // when null/undefined/false returned, the default behaviour is used (for date axis or similar)
            },
            //@ts-ignore
            drawHorizontalBorders: false // plugin: grouped_categories
        },
        yAxis: {
            lineWidth: 0,
            lineColor: "#aaa",
            tickWidth: 1,
            tickColor: "#aaa",
            tickLength: 0,
            gridLineWidth: 1,
            gridLineColor: "#ddd",
            reversedStacks: false,
            title: {
                style: {
                    color: "inherit",
                    fontSize: "95%",
                    fontWeight: "normal"
                }
            },
            labels: {
                style: {
                    color: "inherit",
                    fontSize: "95%",
                    fontWeight: "normal",
                    //whiteSpace: "nowrap"
                },
                formatter: function () {
                    // not a number
                    if (isNaN(+this.value)) {
                        return this.value.toString();
                    }
                    // integer
                    //@ts-ignore
                    if (Math.round(this.axis.tickInterval) === this.axis.tickInterval) {
                        return Highcharts.numberFormat(+this.value, 0);
                    }
                    // decimal
                    //@ts-ignore
                    return Highcharts.numberFormat(this.value, this.axis.tickInterval.toString().split(".")[1].length);
                }
            }
        },
        mapNavigation: {
            enabled: false
        },
        plotOptions: {
            series: {
                shadow: false,
                events: {
                    click: function () {
                        //@ts-ignore
                        if (this.chart.tooltip.isHidden) {
                            this.chart.tooltip.refresh(this.chart.hoverPoints);
                        }
                        else {
                            this.chart.tooltip.hide(0);
                        }
                    }
                },
                dataLabels: {
                    style: {
                        fontSize: "100%"
                    }
                }
            },
            line: {
                lineWidth: 2,
                states: {
                    hover: {
                        lineWidth: 2,
                        brightness: 0
                    }
                },
                marker: {
                    lineWidth: null,
                    symbol: "circle",
                    radius: 0,
                    states: {
                        hover: {
                            radiusPlus: 5,
                            lineWidthPlus: 0
                        }
                    }
                }
            },
            spline: {
                lineWidth: 2,
                states: {
                    hover: {
                        lineWidth: 2,
                        brightness: 0
                    }
                },
                marker: {
                    lineWidth: null,
                    symbol: "circle",
                    radius: 0,
                    states: {
                        hover: {
                            radiusPlus: 5,
                            lineWidthPlus: 0
                        }
                    }
                }
            },
            area: {
                lineWidth: 2,
                states: {
                    hover: {
                        lineWidth: 2,
                        brightness: 0
                    }
                },
                marker: {
                    lineWidth: null,
                    symbol: "circle",
                    radius: 0,
                    states: {
                        hover: {
                            radiusPlus: 5,
                            lineWidthPlus: 0
                        }
                    }
                }
            },
            arearange: {
                lineWidth: 2,
                states: {
                    hover: {
                        lineWidth: 2,
                        brightness: 0
                    }
                },
                marker: {
                    lineWidth: null,
                    symbol: "circle",
                    radius: 0,
                    states: {
                        hover: {
                            radiusPlus: 5,
                            lineWidthPlus: 0
                        }
                    }
                }
            },
            areaspline: {
                lineWidth: 2,
                states: {
                    hover: {
                        lineWidth: 2,
                        brightness: 0
                    }
                },
                marker: {
                    lineWidth: null,
                    symbol: "circle",
                    radius: 0,
                    states: {
                        hover: {
                            radiusPlus: 5,
                            lineWidthPlus: 0
                        }
                    }
                }
            },
            areasplinerange: {
                lineWidth: 2,
                states: {
                    hover: {
                        lineWidth: 2,
                        brightness: 0
                    }
                },
                marker: {
                    lineWidth: null,
                    symbol: "circle",
                    radius: 0,
                    states: {
                        hover: {
                            radiusPlus: 5,
                            lineWidthPlus: 0
                        }
                    }
                }
            },
            column: {
                borderWidth: 0,
                states: {
                    hover: {
                        brightness: 0
                    }
                }
            },
            columnrange: {
                borderWidth: 0,
                states: {
                    hover: {
                        brightness: 0
                    }
                }
            },
            bar: {
                borderWidth: 0,
                states: {
                    hover: {
                        brightness: 0
                    }
                }
            },
            heatmap: {
                borderWidth: 0,
                states: {
                    hover: {
                        brightness: 0
                    }
                }
            },
            scatter: {
                stickyTracking: false,
                marker: {
                    states: {
                        hover: {
                            radiusPlus: 0,
                            lineWidthPlus: 0
                        }
                    }
                }
            },
            bubble: {
                stickyTracking: false,
                marker: {
                    states: {
                        hover: {
                            radiusPlus: 0,
                            lineWidthPlus: 0
                        }
                    }
                }
            },
            map: {
                joinBy: "id",
                borderColor: "#333",
                borderWidth: .5,
                lineWidth: 1,
                stickyTracking: false,
                states: {
                    normal: {
                        animation: false
                    },
                    hover: {
                        brightness: 0,
                        borderWidth: 2, // does not work with 10.1
                    },
                    select: {
                        enabled: false,
                    },
                    inactive: {
                        enabled: false,
                    },
                },
                point: {
                    events: {
                        mouseOver: function () {
                            var _a, _b;
                            //@ts-ignore Graphic is internal.
                            const path = this.graphic;
                            path.toFront();
                            // fix for 10.1
                            //@ts-ignore States Hover is internal?
                            const borderWidth = (_b = (_a = this.series.options.states) === null || _a === void 0 ? void 0 : _a.hover) === null || _b === void 0 ? void 0 : _b.borderWidth;
                            if (borderWidth) {
                                path.attr('stroke-width', borderWidth + 'px');
                            }
                        },
                        // fix for 10.1
                        mouseOut: function () {
                            //@ts-ignore Graphic is internal.
                            const path = this.graphic;
                            path.attr('stroke-width', 'inherit');
                        }
                    }
                },
                tooltip: {
                    headerFormat: '<div style="background: rgba(245,245,245,.8); padding: 8px; margin: -7px -8px -8px -7px;">{point.point.name}<br>',
                    pointFormat: '<span style="color:{point.color}">\u25CF</span> <span style="font-weight:bold">{point.value}</span><br>',
                    footerFormat: '</div>'
                }
            },
            mapline: {
                color: "#333",
                lineWidth: 1,
                showInLegend: false,
                enableMouseTracking: false
            },
            mapbubble: {
                joinBy: "id",
                stickyTracking: false,
                tooltip: {
                    headerFormat: '<div style="background: rgba(245,245,245,.8); padding: 8px; margin: -7px -8px -8px -7px;">{point.point.name}<br>',
                    pointFormat: '<span style="color:{point.color}">\u25CF</span> <span style="font-weight:bold">{point.z}</span><br>',
                    footerFormat: '</div>'
                }
            }
        },
        exporting: {
            sourceWidth: 1200,
            csv: {
                dateFormat: "%Y.%m."
            }
        }
    });
    //@ts-ignore Axis defaults are private members (internal).
    const axisDefaults = Highcharts._modules['Core/Axis/AxisDefaults.js'];
    axisDefaults.defaultLeftAxisOptions.title = {
        x: 10,
        y: -15,
        rotation: 0,
        align: "high",
        textAlign: "left",
    };
    axisDefaults.defaultRightAxisOptions.title = {
        x: -10,
        y: -15,
        rotation: 0,
        align: "high",
        textAlign: "right"
    };
    axisDefaults.defaultBottomAxisOptions.title = {
        x: 0,
        y: 0,
        rotation: 0,
        align: "high",
        textAlign: "right"
    };
    axisDefaults.defaultTopAxisOptions.title = {
        x: 0,
        y: 0,
        rotation: 0,
        align: "high",
        textAlign: "right"
    };
    Highcharts.wrap(Highcharts.Chart.prototype, "init", function (proceed, options, load) {
        if (options.credits && options.credits.text) {
            var series = options.series;
            options.series = null;
            var optionsCopy = Highcharts.merge({}, options);
            options.series = series;
            optionsCopy.series = series;
            options = optionsCopy;
            if (!options.chart)
                options.chart = {};
            if (typeof options.chart.spacingBottom === "undefined") {
                options.chart.spacingBottom = 30;
            }
        }
        return proceed.call(this, options, load);
    });
    //@ts-ignore Map is defined by maps module.
    if (Highcharts.Map) {
        var MapConstructor = function (proceed, a, b, c) {
            var hasRenderToArg = typeof a === 'string' || a.nodeName;
            var options = hasRenderToArg ? b : a;
            // keep original options and series
            var series = options.series;
            options.series = null;
            var optionsCopy = Highcharts.merge({}, options);
            options.series = series;
            optionsCopy.series = series;
            options = optionsCopy;
            // tooltip options
            if (!options.tooltip) {
                options.tooltip = {};
            }
            // no animation since its slow
            if (typeof options.tooltip.animation === "undefined") {
                options.tooltip.animation = false;
            }
            // always hide crosshairs on maps
            if (typeof options.tooltip.crosshairs === "undefined") {
                options.tooltip.crosshairs = false;
            }
            if (!options.xAxis)
                options.xAxis = {};
            if (typeof (options.xAxis || {}).crosshair === "undefined") {
                options.xAxis.crosshair = false;
            }
            if (!options.yAxis)
                options.yAxis = {};
            if (typeof (options.yAxis || {}).crosshair === "undefined") {
                options.yAxis.crosshair = false;
            }
            // tooltip follow mouse movement
            if (typeof options.tooltip.positioner === "undefined") {
                options.tooltip.positioner = function (boxWidth, boxHeight, point) {
                    var chart = this.chart, x = point.plotX + 25, y = point.plotY + 50;
                    if ((x + boxWidth) > (chart.plotLeft + chart.plotWidth)) {
                        x -= (x + boxWidth) - (chart.plotLeft + chart.plotWidth);
                    }
                    if ((y + boxHeight) > (chart.plotTop + chart.plotHeight)) {
                        y = Math.max(chart.plotTop, chart.plotTop + chart.plotHeight - boxHeight);
                    }
                    return {
                        x: x,
                        y: y
                    };
                };
            }
            // prevent zooming in too much
            if (!options.xAxis)
                options.xAxis = {};
            if (typeof options.xAxis.minRange === "undefined") {
                options.xAxis.minRange = 300; //680;
            }
            // configure legend when dataClasses are present in colorAxis
            if (options.colorAxis && options.colorAxis.dataClasses) {
                if (!options.legend)
                    options.legend = {};
                var legendPads = [{
                        pattern: /[\d-]/g,
                        padChar: "\u2007", // FIGURE SPACE - this is equivalent to the digit width of fonts
                    }, {
                        pattern: /[\u2013\u2212]/g,
                        padChar: "\u2002\u200A", // EN SPACE + HAIR SPACE
                    }];
                function getCharClassCounts(text) {
                    var result = [];
                    for (var i = 0; i < legendPads.length; i++) {
                        var m = text.match(legendPads[i].pattern);
                        result.push(m ? m.length : 0);
                    }
                    return result;
                }
                function analyzeDataClasses(dataClasses, valueDecimals) {
                    var longestFrom = "";
                    var longestTo = "";
                    for (var i = 0; i < dataClasses.length; i++) {
                        var dc = dataClasses[i];
                        if (typeof dc.from === "number") {
                            var fromFormatted = Highcharts.numberFormat(dc.from, valueDecimals);
                            if (fromFormatted.length > longestFrom.length) {
                                longestFrom = fromFormatted;
                            }
                        }
                        if (typeof dc.to === "number") {
                            var toFormatted = Highcharts.numberFormat(dc.to, valueDecimals);
                            if (toFormatted.length > longestTo.length) {
                                longestTo = toFormatted;
                            }
                        }
                    }
                    return {
                        from: getCharClassCounts(longestFrom),
                        to: getCharClassCounts(longestTo),
                    };
                }
                var legendOptions = {
                    useHTML: true,
                    floating: true,
                    align: "right",
                    verticalAlign: "bottom",
                    layout: "vertical",
                    backgroundColor: "white",
                    padding: 14,
                    itemMarginTop: 0,
                    itemMarginBottom: 4,
                    symbolRadius: 0,
                    symbolHeight: 14,
                    symbolWidth: 14,
                    labelFormatter: function () {
                        if (!this.name)
                            return; // bubbleLegend
                        if (this.name[0] === "=") {
                            return this.name.substr(1);
                        }
                        var options = this.chart.options;
                        var colorAxis = options.colorAxis;
                        var dataClasses = colorAxis ? (colorAxis.dataClasses || colorAxis[0].dataClasses) : [];
                        var valueDecimals = options.legend ? options.legend.valueDecimals || 0 : 0;
                        if (!this.chart.dataClassInfo) {
                            this.chart.dataClassInfo = analyzeDataClasses(dataClasses, valueDecimals);
                        }
                        var dataClassInfo = this.chart.dataClassInfo;
                        var fromText = (typeof this.from === "number") ? Highcharts.numberFormat(this.from, valueDecimals) : "";
                        var toText = (typeof this.to === "number") ? Highcharts.numberFormat(this.to, valueDecimals) : "";
                        if ((!fromText || !toText) && !(this.name[0] === "<" || this.name[0] === ">")) {
                            return this.name;
                        }
                        var fromCharClasses = getCharClassCounts(fromText);
                        var toCharClasses = getCharClassCounts(toText);
                        for (var i = 0; i < legendPads.length; i++) {
                            for (var j = fromCharClasses[i]; j < dataClassInfo.from[i]; ++j)
                                fromText = legendPads[i].padChar + fromText;
                            for (var j = toCharClasses[i]; j < dataClassInfo.to[i]; ++j)
                                toText = legendPads[i].padChar + toText;
                        }
                        const invisibleSep = '\u2063';
                        return invisibleSep + fromText + "\u00a0\u2013\u00a0" + toText;
                    }
                };
                for (var k in legendOptions) {
                    if (typeof options.legend[k] === "undefined") {
                        options.legend[k] = legendOptions[k];
                    }
                }
            }
            return hasRenderToArg ? proceed.call(this, a, options, c) : proceed.call(this, options, b);
        };
        Highcharts.wrap(Highcharts, "mapChart", MapConstructor);
        Highcharts.wrap(Highcharts, "Map", MapConstructor);
    }
    Highcharts.wrap(Highcharts.Chart.prototype, 'getDataRows', function (proceed, multiLevelHeaders) {
        var _a, _b, _c, _d, _e, _f, _g;
        const lang = Highcharts.getOptions().lang;
        const csv = proceed.apply(this, multiLevelHeaders);
        const head = csv[0];
        switch (head[0]) {
            case 'Category':
                if (lang.csvCategory)
                    head[0] = lang.csvCategory;
                break;
            case 'DateTime':
                if (lang.csvDateTime)
                    head[0] = lang.csvDateTime;
                break;
        }
        const valueSuffix = [null];
        for (let i = 0; i < this.series.length; i++) {
            if (this.series[i].visible) {
                const tooltip = (_g = (_d = (_c = (_b = (_a = this.series[i]) === null || _a === void 0 ? void 0 : _a.options) === null || _b === void 0 ? void 0 : _b.tooltip) === null || _c === void 0 ? void 0 : _c.valueSuffix) !== null && _d !== void 0 ? _d : (_f = (_e = this.tooltip) === null || _e === void 0 ? void 0 : _e.options) === null || _f === void 0 ? void 0 : _f.valueSuffix) !== null && _g !== void 0 ? _g : null;
                valueSuffix.push(tooltip);
            }
        }
        for (let j = 1; j < head.length; j++) {
            if (valueSuffix[j]) {
                if (head[j]) {
                    head[j] += ' [' + valueSuffix[j].trim() + ']';
                }
                else {
                    head[j] = valueSuffix[j].trim();
                    head[j] = head[j].charAt(0).toUpperCase() + head[j].slice(1);
                }
            }
        }
        return csv;
    });
}
export default configure;
